import React from 'react';

const EndSVG = ({ color = 'black', className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      className={className}
      {...props}
    >
      <path
        d="M6.40001 2.91684H5.50001C3.37869 2.91684 2.31802 2.91684 1.65901 3.57585C1 4.23486 1 5.29552 1 7.41685V11.9169C1 14.0382 1 15.0988 1.65901 15.7579C2.31802 16.4169 3.37869 16.4169 5.50001 16.4169H6.40001"
        stroke={color}
        strokeWidth="1.2"
      />
      <path
        d="M6.40039 4.6956C6.40039 2.63117 6.40039 1.59896 7.03692 1.03467C7.67344 0.470374 8.64634 0.640069 10.5922 0.97946L12.6882 1.34502C14.8432 1.7209 15.9207 1.90883 16.5606 2.69927C17.2004 3.48971 17.2004 4.63289 17.2004 6.91924V12.4145C17.2004 14.7008 17.2004 15.844 16.5606 16.6344C15.9207 17.4249 14.8432 17.6128 12.6882 17.9887L10.5922 18.3542C8.64634 18.6936 7.67344 18.8633 7.03692 18.299C6.40039 17.7347 6.40039 16.7025 6.40039 14.6381V4.6956Z"
        stroke={color}
        strokeWidth="1.2"
      />
      <path
        d="M9.09961 8.76685V10.5668"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default EndSVG;
